export const duration = 300;

export const defaultStyle = {
  transition: `max-height ${duration}ms ease-in-out`,
  maxHeight: '0px',
  overflow: 'hidden'
};

export const transitionStyles = {
  entering: { maxHeight: '60px' },
  entered: { maxHeight: '60px' },
  exiting: { maxHeight: '0' },
  exited: { maxHeight: 0 },
  unmounted: { maxHeight: 0 }
};
